import React from 'react';

import { Objects } from '@pitaman71/omniglot-live-data';
import { Plugin as GoalPlugin } from './OfGoals';

export enum Position {
  Backward = 'backward',
  Forward = 'forward',
  Primary = 'primary',
  Settings = 'settings',
  Secondary = 'secondary'
};

interface Options<AuthorityTags> {
  relevant?: (route: string, hasTag: (tag: AuthorityTags) => boolean) => boolean;
  permitted?: (route: string, hasTag: (tag: AuthorityTags) => boolean) => boolean;
  position?: () => Position;
};

export class Factory<BindingType extends Objects.BindingType, AuthorityTags> {
    _prefix: string[];
    _parameterNames: (keyof BindingType)[];
    _build: (binding: BindingType, factory: this) => GoalPlugin;
    _options: Options<AuthorityTags>;
    constructor(
      prefix: string[] = [], // route path prefix
      parameterNames: (keyof BindingType)[],  // names of the binding parameters (db object symbols) required to invoke this route
      build: (binding: BindingType, factory: Factory<BindingType, AuthorityTags>) => GoalPlugin,
      options?: Options<AuthorityTags>
    ) {
        this._prefix = prefix;
        this._parameterNames = parameterNames;
        this._build = build;
        this._options = options || {};
    }
    position() {
        return !!this._options.position ? this._options.position() : this._prefix.length <= 1 && this._parameterNames.length === 0 ? Position.Primary : Position.Secondary;
    }
    relevant(route: string, hasTag: (tag: AuthorityTags) => boolean) {
      return !this._options.relevant || this._options.relevant(route, hasTag);
  }
    permitted(route:string, hasTag: (tag: AuthorityTags) => boolean) {
      return !this._options.permitted || this._options.permitted(route, hasTag);
    }
    asPath() { 
      const key = (separator: string) => this._prefix.join(separator);
      const pattern = '/'+[ ...this._prefix, ... this._parameterNames.map(name => ':'+name.toString()) ].join('/');
      const to = (binding: BindingType): string => {
          return '/'+[ ...this._prefix, ... this._parameterNames.map(name => binding[name.toString()]?.objectId || "?") ].join('/');
      }
      return { key, pattern, to } 
    }
    asParameters() { return {
        from: (parameters:any) => {
            const binding: Partial<BindingType> = {};
            for(const key of this._parameterNames) {
                if(!parameters.hasOwnProperty(key.toString())) return undefined;
                binding[key] = Objects.Binding.from_bound(parameters[key.toString()]) as any;
            }
            return binding as BindingType;
        }
    }}
    make(binding: BindingType) { return this._build(binding, this) }
}

export type Table<T> = {
    [P in keyof T]: GoalPlugin
};

export let All: Factory<any, any>[] = [];

import * as OfControls from './OfControls';
import * as OfFields from './OfFields';
import * as OfGoals from './OfGoals';

export { OfControls, OfFields, OfGoals };

